import { render, staticRenderFns } from "./SetUpPlayer.vue?vue&type=template&id=6c3036ca&"
import script from "./SetUpPlayer.vue?vue&type=script&lang=js&"
export * from "./SetUpPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SetUpPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports